import {
  GET_SOFTSKILLS_USERS_ALL,
  GET_SOFTSKILLS_USERS_ALL_SUCCESS,
  GET_SOFTSKILLS_USERS_ALL_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  users: [],
}

const SoftskillsUsersAll = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOFTSKILLS_USERS_ALL:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SOFTSKILLS_USERS_ALL_SUCCESS:
      state = {
        ...state,
        users: action.payload.users,
        loading: false,
        done: true,
      }
      break
    case GET_SOFTSKILLS_USERS_ALL_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsUsersAll
